import type { components } from '@connected/api-client/api.generated';

import { Button } from '@connected/ui/components/button';
import {
    Popout,
    PopoutBody,
    PopoutContent,
    PopoutFooter,
    PopoutHeader,
    PopoutTitle,
} from '@connected/ui/components/popout';

import { ValidationErrorItem } from './validation-error-item';

export type ValidationErrorsModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    validationItems: components['schemas']['ElectricalProjectValidationResult'][];
    onForceCreate: () => void;
    isCreating: boolean;
    isOffline: boolean;
};

export function ValidationErrorsModal({
    open,
    onOpenChange,
    validationItems,
    onForceCreate,
    isCreating,
    isOffline,
}: ValidationErrorsModalProps) {
    return (
        <Popout open={open} onOpenChange={onOpenChange}>
            <PopoutContent aria-describedby="observation-content-description" className="max-w-xl">
                <PopoutHeader>
                    <PopoutTitle>
                        Validatiefouten (
                        {validationItems?.length || 0}
                        )
                    </PopoutTitle>
                </PopoutHeader>
                <PopoutBody className="gap-6 py-6">
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            {validationItems?.map((error, index) => (
                                <ValidationErrorItem
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`${error.ElectricalProjectVersionId}-${index}`}
                                    itemError={error}
                                />
                            ))}
                        </div>
                    </div>
                </PopoutBody>
                <PopoutFooter>
                    <Button
                        className="w-full"
                        variant="outline"
                        onClick={() => {
                            onOpenChange(false);
                        }}
                    >
                        Terug
                    </Button>
                    <Button
                        className="w-full"
                        onClick={onForceCreate}
                        disabled={isCreating || isOffline}
                    >
                        Rapport toch maken
                    </Button>
                </PopoutFooter>
            </PopoutContent>
        </Popout>
    );
}
